import { BasePath } from '@constants/Auth';
import DateFnsUtils from '@date-io/date-fns';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { handleApiError } from '@services/http';
import { AuthProvider, AuthService } from '@swyft/auth';
import { ConfigureLogger, Log } from '@swyft/core';
import { BaseMuiTheme } from '@swyft/ui';
import { AppProvider } from '@utils/appState';
import { getConfig } from '@utils/config';
import { history } from '@utils/history';
import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { defaultLocale, dynamicActivate } from './i18n';
import { AppRoutes } from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 10_000,
      retry: false
    }
  }
});

ConfigureLogger(Log.ERROR, console);

const config = getConfig();
const authService = new AuthService({
  authority: config.AuthAuthority,
  clientId: config.AuthClientId,
  basePath: BasePath,
  handleRedirectCallbackState: (path?: string) => history.push(`${BasePath}${path || '/'}`)
});

function App(): JSX.Element {
  React.useEffect(() => {
    // With this method we dynamically load the catalogs
    dynamicActivate(defaultLocale);
  }, []);

  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <I18nProvider i18n={i18n}>
        <AuthProvider authService={authService} handleApiError={handleApiError}>
          <QueryClientProvider client={queryClient}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <AppProvider>
                <AppRoutes />
              </AppProvider>
            </MuiPickersUtilsProvider>
          </QueryClientProvider>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
